<template>
  <Loader :visible="isLoggingIn" :text="t('login.loading')"></Loader>
</template>

<script setup lang="ts">
import axios from 'axios'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserProfileStore } from '../../stores/userProfileStore'
import type { OktaAuthData } from '../../types/auth/oktaAuthData'
import { UserProfileData } from '../../types/userProfile/userProfileData'
import { OauthOption } from '../../types/auth/oauthOption'
import { normalizeAuthData } from '../../composables/auth/normalizeAuthData'
import { t } from '../../composables/Translation'
import { useChatStore } from '../../stores/chatStore'
import { useAppStore } from '../../stores/appStore'
import { useAidaSessionStore } from '../../stores/aidaSessionStore'
import Loader from '../Loader.vue'
import { useToast } from '../../composables/useToast'

const backendAuthURL = `${import.meta.env.VITE_BACKEND_BASE_URL}/oauth/callback/okta`
const router = useRouter()
const toast = useToast()

const userProfileStore = useUserProfileStore()
const chatStore = useChatStore()
const appStore = useAppStore()
const aidaSessionStore = useAidaSessionStore()
const isLoggingIn = ref(false)

onMounted(async () => {
  chatStore.restoreAfterRedirect()
  appStore.restoreAfterRedirect()
  aidaSessionStore.restoreAfterRedirect()
  const parameters = window.location.search.slice(1)
  const url = backendAuthURL + '?' + parameters

  const headers = { headers: { 'Content-Type': 'application/json' } }
  try {
    isLoggingIn.value = true
    const response = await axios.get(url, headers)
    if (response?.data) {
      const data = response.data as OktaAuthData
      const normalized = normalizeAuthData(data, OauthOption.Okta)
      const userProfile = new UserProfileData(normalized, OauthOption.Okta)
      userProfileStore.setUserProfile(userProfile)
      router.push({ name: 'main' })
    }
  } catch (err: any) {
    toast.error(t('login.genericError'))
    router.push({ name: 'main' })
  } finally {
    isLoggingIn.value = false
  }
})
</script>
